import { BasicPieChart } from "@components/items/display/PieChart";
import { ProgressBar } from "@components/items/display/ShadcnProgressBar";
import { Server } from "@wajeez/wajeez.microservices";
import TranslatedText from "@components/items/display/TranslatedText";

interface CategoriesProps {
  data: Server.GetUserTopConsumedCategoriesOutput[];
}

const colors = ["#2797FF", "#FF4E48", "#FFD541", "#0CD769", "#4757E9"];

const Categories = ({ data }: CategoriesProps) => {
  const mappedData = data.map((d, i) => {
    return {
      ...d,
      color: colors[i],
    };
  });

  return (
    <div className="flex w-full flex-col items-start justify-center rounded-lg bg-[#D9D9D9]/15 p-6 text-black dark:text-white">
      <TranslatedText
        text={`settings.titles.${"categories"}`}
        className="text-[25px] font-medium"
      />
      <div className="flex w-full items-center justify-start">
        <div>
          <BasicPieChart
            data={mappedData.map((md) => {
              return {
                label: md.title || "",
                value: md.percentage || 0,
              };
            })}
            colors={colors}
          />
        </div>
        <div className="grid w-full grid-cols-2 gap-12">
          {mappedData?.map(({ title, percentage, color }, index) => (
            <div
              key={index}
              className="flex w-full flex-col items-start justify-center"
            >
              <div className="text-[15px] font-medium">{title}</div>
              <div className="flex w-full items-center justify-start gap-5">
                <ProgressBar
                  value={percentage || 0}
                  height="h-1"
                  bgStyle="bg-gray-300"
                  prgresserBgColor={color}
                />
                <div className="text-nowrap text-[17px]">{`${percentage} %`}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* <TranslatedText
        text={`settings.titles.${"your favourite categories"}`}
        className="text-[17px] self-end"
      /> */}
    </div>
  );
};

export default Categories;
